module.exports = __webpack_public_path__ + "static/img/xingFull.8ac8ccbf.svg";